import { render, staticRenderFns } from "./add-article.vue?vue&type=template&id=a4fb8668&scoped=true&"
import script from "./add-article.vue?vue&type=script&lang=js&"
export * from "./add-article.vue?vue&type=script&lang=js&"
import style0 from "./add-article.vue?vue&type=style&index=0&id=a4fb8668&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4fb8668",
  null
  
)

export default component.exports